var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "#86CF96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1113 51.1398L42.9368 71.2606L80.8891 32.7422",
    stroke: "white",
    strokeWidth: 5.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedDone);
export default __webpack_public_path__ + "static/media/completedDone.9ffe1ed663dfc338e8a903e3f1201d05.svg";
export { ForwardRef as ReactComponent };